import { useTheme } from '@mui/material/styles';
import { sdsColors, sdsGrayscale } from '../../../theme/sds-tokens';
import { chartMutedTextColor, chartNeutralColor } from './chartColors';

export const EmptyPieChart = ({ variant = 'pie' }: { variant?: 'pie' | 'doughnut' }) => {
  const { palette } = useTheme();
  const isDark = palette.mode === 'dark';
  const neutral = chartNeutralColor(isDark);
  const isDoughnut = variant === 'doughnut';

  return (
    <div
      role="img"
      aria-label="Sem dados no período"
      style={{
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        aspectRatio: '1',
        borderRadius: '50%',
        background: isDoughnut ? 'transparent' : neutral,
        border: isDoughnut ? `solid ${neutral}` : 'none',
        borderWidth: isDoughnut ? 'max(12px, 16%)' : 0,
        fontSize: 12,
        fontWeight: 600,
        color: isDoughnut ? chartMutedTextColor(isDark) : isDark ? sdsGrayscale[0] : sdsColors.textPrimary,
      }}
    >
      Sem dados
    </div>
  );
};
